import { jsx as _jsx } from "react/jsx-runtime";
import { Heading as DSHeading } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./heading.module.css";
export var Heading = function(param) {
    var children = param.children, className = param.className, _element = param.element, element = _element === void 0 ? "h2" : _element;
    return /*#__PURE__*/ _jsx(DSHeading, {
        element: element,
        className: cx(styles.root, className),
        children: children
    });
};
